import $ from 'jquery';
import cart from '@wc-stripe/cart';
import AbstractMessage from './AbstractMessage';

class CartMessage extends AbstractMessage {

    initActions() {
        this.actions.addAction('cart_updated', this.onCartChanged.bind(this), 20);
    }

    onCartChanged() {
        if (this.messageElement) {
            this.updateElement();
            if (this.hasPaymentMethodTypes()) {
                this.mountElement();
            } else {
                this.unmountElement();
            }
        }
    }

    showMessageElement() {
        $('.wc-stripe-bnpl-cart-message').show();
    }

    getTotalCents() {
        return cart.getTotalCents();
    }

    getCurrency() {
        return cart.getCurrency();
    }

    getElementContainer() {
        let el = super.getElementContainer();
        if (!el) {
            const id = this.selector.replace('#', '');
            if (this.location === 'below_total') {
                const tr = document.createElement('tr');
                tr.className = 'wc-stripe-bnpl-cart-message';
                tr.innerHTML = `<td colspan="2"><div id="${id}"></div></td>`;
                const anchor = document.querySelector('.cart_totals .order-total');
                if (anchor) {
                    anchor.after(tr);
                }
                el = document.getElementById(id);
            } else {
                el = document.createElement('div');
                el.id = id;
                el.className = 'wc-stripe-bnpl-cart-message';
                const anchor = document.querySelector('.wc-proceed-to-checkout')
                    || document.querySelector('.cart_totals');
                if (anchor) {
                    anchor.after(el);
                }
            }
        }
        return el;
    }
}

export default CartMessage;